<template>
    <!--不具备中金支付白名单权限-->
    <div class="no-permission-wrapper flex-all-center">
        中金支付功能仍处于封闭测试中，仅授权企业可以使用。请耐心等待功能发布。
    </div>
</template>

<script>
   export default {
    name: "noPermission",
  }
</script>

<style scoped lang="scss">
.no-permission-wrapper{
    width: 100%;
    height: calc(100vh - 160px);
}
</style>